import { render } from "./AboutUs.vue?vue&type=template&id=e6ad402c"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=e6ad402c&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__